import React from "react";
import "./index.scss";

import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import pres1 from "../../../assets/images/pres1.png";
import pres2 from "../../../assets/images/pres2.png";
import pres3 from "../../../assets/images/pres3.png";
import pres4 from "../../../assets/images/pres4.png";
import pres5 from "../../../assets/images/pres5.png";
import pres6 from "../../../assets/images/pres6.png";
import { FlechCercle } from "../../../assets/icons/FlechCercle";

export const Prestations = ({ title, description }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false, // Direction de droite à gauche
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1500, // En dessous de 768px (mobile)
        settings: {
          slidesToShow: 3, // Affiche 3 drapeaux
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },

      {
        breakpoint: 480, // En dessous de 480px (petit mobile)
        settings: {
          slidesToShow: 1, // Affiche 2 drapeaux
          slidesToScroll: 1,
        },
      },
    ],
  };
  const prestations = [
    {
      image: pres1,
      title: "Isolation thermique par l’extérieur (ITE)",
      description: "Pour réduire vos déperditions et vos factures.",
      linkText: "/ITE",
    },
    {
      image: pres2,
      title: "Isolation intérieure (ITI)",
      description: "Idéale pour les appartements ou les murs mitoyens.",
      linkText: "/ITI",
    },
    {
      image: pres3,
      title: "Isolation de toiture",
      description: "Premier poste de perte de chaleur.",
      linkText: "/toiture",
    },
    {
      image: pres4,
      title: "Ravalement de façade",
      description:
        "À la chaux ou anti-fissures, pour embellir et protéger votre bien.",
      linkText: "/ravalement-façade",
    },
    {
      image: pres5,
      title: "Rénovation globale pour investisseurs",
      description:
        "Un service clé en main pour optimiser la valeur de vos biens à rénover.",
      linkText: "/renovation-investisseurs",
    },
    {
      image: pres6,
      title: "Aides & accompagnement administratif",
      description:
        "On vous guide dans toutes les démarches pour obtenir MaPrimeRénov’, CEE, TVA réduite, etc.",
      linkText: "/accompagnement-administratif",
    },
  ];
  return (
    <div className="realisation mt-5 mb-5">
      <div className="realisation-header ">
        <div className="realisation-title">{title}</div>
        <div className="realisation-subtitle mt-3 mb-5">{description}</div>

        <Slider {...settings} className="margin-slider">
          {prestations.map((prestation, index) => (
            <div className="service-card" key={index}>
              <img
                src={prestation.image}
                className="card-img-top"
                alt={prestation.title}
              />
              <div className="card-body">
                <h5
                  className="card-title"
                  dangerouslySetInnerHTML={{ __html: prestation.title }}
                />
                <p className="card-text">{prestation.description}</p>

                {/* Lien toujours en bas */}
                <a
                  href={prestation.linkText}
                  className="service-link d-flex justify-content-between align-items-center">
                  Demandez ce service <FlechCercle />
                </a>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};
